import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { StageSection, type StageSectionProps } from './StageSection.tsx';
import './stage-section.css';

// Provides the `review.stageSection` extension: the shared frame for a section
// of a stage panel. A section plugin wraps its body in it:
//
//   <app.Extension name="review.stageSection" params={{ title: 'History' }}>
//     <HistoryTable … />
//   </app.Extension>
//
// The plugin owns the title style and the spacing; section plugins own their
// body and whether to render at all.

export type StageSectionParams = Omit<StageSectionProps, 'children'>;

export function setup(app: PiletApi) {
  app.registerExtension<StageSectionParams>('review.stageSection', ({ params, children }) => (
    <StageSection title={params.title} aside={params.aside} tooltip={params.tooltip}>
      {children}
    </StageSection>
  ));
}
